export default __webpack_public_path__ + "static/media/disciplinewillofvivification.4e08603e.png";